/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import { HOME_ROOM } from "../RoomNameConstants";

const state = {
    ID: HOME_ROOM,
    kpi: {
        list: {
            "Available Workstations": null,
            "Unavailable Workstations": null,
            "Pending Prompts": null,
            "Min Duration": null,
            "Jobs In Late": null,
            "Jobs In Error": null,
        },
        info: {
            "Available Workstations": null,
            "Unavailable Workstations": null,
            "Pending Prompts": null,
            "Min Duration": null,
            "Jobs In Late": null,
            "Jobs In Error": null,
        },
        settings: {},
        opened: null,
    },
    criticalJobsData: {
        "Critical Jobs Info High Risk": [],
        "Critical Jobs Info Potential Risk": [],
        "Critical Jobs Info No Risk": [],
    },
    dataRightChart: {
        values: [
            {
                values: [20],
                labels: [],
                colors: ["#363636"],
            },
            {
                values: [10],
                labels: ["Running"],
                colors: ["#363636"],
            },
            {
                values: [10],
                labels: ["Successful"],
                colors: ["#363636"],
            },
            {
                values: [18],
                labels: ["Error"],
                colors: ["#363636"],
            },
            {
                values: [22],
                labels: ["Suppressed"],
                colors: ["#363636"],
            },
        ],
        labels: [],
        selected: null,
    },
    currentPlanDates: [],
};

export default state;
